import PromptInput from "common/widgets/PromptList/PromptInput";
import NumericTextInput from "app/widgets/TextInput/NumericTextInput";
const IntegerPromptInput = PromptInput.extend({
    options: {
        name: "IntegerPromptInput"
    },
    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this.widget = new NumericTextInput(this.input, {
            decimals: 0,
            placeholder: this.options.model.get("placeholder"),
            max: 2147483647,
            min: -2147483648
        });
        // set class needed for applying styles to set width / height / labelPosition correctly,
        // based on control type
        if (this.options.model.width && this.options.model.height) {
            this.element.parent().addClass("numericControl flexLayout");
        }

        this.widget.bind("change", this.handleChange);
        this.refresh();
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }

        PromptInput.fn.destroy.apply(this, arguments);
    },

    getMinSize: function() {
        var minSize = PromptInput.fn.getMinSize.apply(this, arguments);
        minSize.width = 20;
        return minSize;
    },

    getInputWidth: function() {
        return this.widget.wrapper.outerWidth(true);
    }
});
kendo.ui.plugin(IntegerPromptInput);
export default IntegerPromptInput;
